export default "__VITE_ASSET__Du7U7eg0__"